import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  {
    project,
    fromProjectResource,
    toProjectResource,
  }: Boundaries["transferProjectResourceAllocations"]["request"],
): State {
  const index = state.findIndex(
    (res) =>
      res.project.uuid === project.uuid &&
      res.fromProjectResource.uuid === fromProjectResource.uuid &&
      res.toProjectResource.uuid === toProjectResource.uuid,
  );

  return [
    ...state.slice(0, index),
    {
      project,
      fromProjectResource,
      toProjectResource,
      request: setRequestStateToPending(),
    },
    ...state.slice(index + 1),
  ];
}

function handleSuccess(
  state: State,
  {
    project,
    fromProjectResource,
    toProjectResource,
  }: Boundaries["transferProjectResourceAllocations"]["success"],
): State {
  return state.map((res) =>
    res.project.uuid === project.uuid &&
    res.fromProjectResource.uuid === fromProjectResource.uuid &&
    res.toProjectResource.uuid === toProjectResource.uuid
      ? { ...res, request: setRequestStateToSuccess() }
      : res,
  );
}

function handleFailure(
  state: State,
  {
    project,
    fromProjectResource,
    toProjectResource,
  }: Boundaries["transferProjectResourceAllocations"]["failure"],
): State {
  return state.map((res) =>
    res.project.uuid === project.uuid &&
    res.fromProjectResource.uuid === fromProjectResource.uuid &&
    res.toProjectResource.uuid === toProjectResource.uuid
      ? { ...res, request: setRequestStateToFailure() }
      : res,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.transferProjectResourceAllocationsRequested]: handleRequest,
    [events.transferProjectResourceAllocationsSucceeded]: handleSuccess,
    [events.transferProjectResourceAllocationsFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
